/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDocumented } from '../../models/paginated-documented';
import { RegistrazioneResDto } from '../../models/registrazione-res-dto';

export interface RegistrazioniControllerFindManyRegistrazioni$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by persona.id query param.
   *
   * **Format:** filter.persona.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.id=$eq:John Doe&filter.persona.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.id'?: Array<string>;

  /**
   * Filter by struttura.nome query param.
   *
   * **Format:** filter.struttura.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.struttura.nome=$eq:John Doe&filter.struttura.nome=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.struttura.nome'?: Array<string>;

  /**
   * Filter by stato.nome query param.
   *
   * **Format:** filter.stato.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.stato.nome=$btw:John Doe&filter.stato.nome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.stato.nome'?: Array<string>;

  /**
   * Filter by dal query param.
   *
   * **Format:** filter.dal={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.dal=$eq:John Doe&filter.dal=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.dal'?: Array<string>;

  /**
   * Filter by al query param.
   *
   * **Format:** filter.al={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.al=$eq:John Doe&filter.al=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.al'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=persona.id:DESC
   *
   *
   * **Default Value:** id:ASC
   *
   * **Available Fields**
   * - id
   *
   * - persona.id
   *
   * - struttura.id
   *
   * - stato.id
   *
   * - dal
   *
   * - al
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'persona.id:ASC'
    | 'persona.id:DESC'
    | 'struttura.id:ASC'
    | 'struttura.id:DESC'
    | 'stato.id:ASC'
    | 'stato.id:DESC'
    | 'dal:ASC'
    | 'dal:DESC'
    | 'al:ASC'
    | 'al:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,persona.id,struttura.id,stato.id,dal
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - persona.id
   *
   * - struttura.id
   *
   * - stato.id
   *
   * - dal
   *
   * - al
   */
  searchBy?: Array<string>;
}

export function registrazioniControllerFindManyRegistrazioni(
  http: HttpClient,
  rootUrl: string,
  params?: RegistrazioniControllerFindManyRegistrazioni$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<RegistrazioneResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'persona.id'?: string | Array<string>;
          'struttura.nome'?: string | Array<string>;
          'stato.nome'?: string | Array<string>;
          dal?: string | Array<string>;
          al?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    registrazioniControllerFindManyRegistrazioni.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query('filter.persona.id', params['filter.persona.id'], {});
    rb.query('filter.struttura.nome', params['filter.struttura.nome'], {});
    rb.query('filter.stato.nome', params['filter.stato.nome'], {});
    rb.query('filter.dal', params['filter.dal'], {});
    rb.query('filter.al', params['filter.al'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<RegistrazioneResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'persona.id'?: string | Array<string>;
                'struttura.nome'?: string | Array<string>;
                'stato.nome'?: string | Array<string>;
                dal?: string | Array<string>;
                al?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

registrazioniControllerFindManyRegistrazioni.PATH = '/admin/registrazione';
